export const AvailableMenus = {
  None: "none",
  BattData: "navigation.basedata.label",
  User: "user",
} as const;
type AvailableMenuKey = keyof typeof AvailableMenus;
export type AvailableMenuValue = typeof AvailableMenus[AvailableMenuKey];

export const isAvailableMenuValue = (x: unknown): x is AvailableMenuValue => Object.values(AvailableMenus).includes(x as AvailableMenuValue);
